import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@follosoft/react-components";

import type { ClauseResource } from "../types";

export function useAvailableClausesService(contractId?: number | string) {
  return useQuery<ClauseResource[]>({
    queryKey: ["available-clauses", Number(contractId)],
    queryFn: async () => {
      const res = await axiosInstance().get(`/folloportal/clauses/available`, {
        params: {
          "meta[contract_id]": contractId,
        },
      });

      return res.data.data ?? [];
    },
    enabled: !!contractId,
    staleTime: 0,
  });
}
